/* ==================================================================
   nightforce-pdp.js — product-page-only modules, split out of
   nightforce-main.js (2026-08-15 perf pass). Loaded with defer AFTER
   nightforce-main.js on product templates only; execution order is
   guaranteed by defer, and fnPDP reads window.fnMoney at run time.
   ================================================================== */
/* =============================================================
   v5.0 — PDP: variant resolver, bundle qty, buy-now, thumbs, recs.
   The brief's variant pills ship no switching logic; this wires them
   to product.variants (price/compare/availability/image/URL). The
   add-to-cart form is AJAXed so it opens the v4 cart drawer.
   ============================================================= */
(function fnPDP() {
  'use strict';
  var money = window.fnMoney || function (c) { return (Number(c) / 100).toFixed(2) + ' €'; };

  var pdpForm = document.querySelector('.fn-pdp__form');

  /* ---- variant selection ---- */
  var variantDataEl = document.querySelector('[data-pdp-variant-data]');
  if (pdpForm && variantDataEl) {
    var variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) {}
    var idInput = pdpForm.querySelector('[data-product-variant-id]');
    /* "U košarico" (AJAX-only, type="button") — sole PDP CTA (Buy Now removed) */
    var addBtn    = pdpForm.querySelector('[data-fn-pdp-add]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var discountEl = document.querySelector('[data-pdp-discount]');
    var mainImg = document.querySelector('[data-pdp-main-image]');

    var selectedValues = function () {
      var vals = [];
      document.querySelectorAll('.fn-pdp__option').forEach(function (grp) {
        var idx = parseInt(grp.getAttribute('data-option-index'), 10);
        var active = grp.querySelector('.fn-variant-pill.is-active');
        vals[idx] = active ? active.getAttribute('data-option-value') : null;
      });
      return vals;
    };
    var findVariant = function (vals) {
      return variants.find(function (v) {
        return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
      });
    };
    var imgSrc = function (fi) {
      if (!fi) return null;
      return typeof fi === 'string' ? fi : (fi.src || null);
    };
    var updateVariant = function () {
      var v = findVariant(selectedValues());
      if (!v) {
        if (addBtn)    { addBtn.disabled = true; addBtn.textContent = 'Kombinacija ni na voljo'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
          if (discountEl) {
            discountEl.style.display = '';
            discountEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          }
        } else {
          compareEl.style.display = 'none';
          if (discountEl) discountEl.style.display = 'none';
        }
      }
      /* AJAX add-to-cart button text + availability */
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Dodaj v košarico' : 'Trenutno ni na voljo';
      }
      var relBtn = document.getElementById('rsi_buy_now_button') || document.getElementById('_rsi-buy-now-button');
      if (relBtn) relBtn.disabled = !v.available;
      /* Also update the releasit-cob container's variant attribute for data-driven sync */
      var relCob = document.getElementById('releasit-cob') || document.querySelector('[id^="releasit-cob"]');
      if (relCob) {
        relCob.setAttribute('data-releasit-variant-id', v.id);
        relCob.dataset.releasitVariantId = v.id;
        relCob.dataset.variantId = v.id;
      }
      var src = imgSrc(v.featured_image);
      if (src && mainImg) mainImg.src = src;
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    };

    document.querySelectorAll('.fn-pdp__variants').forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var pill = e.target.closest('.fn-variant-pill');
        if (!pill) return;
        var grp = pill.closest('.fn-pdp__option');
        grp.querySelectorAll('.fn-variant-pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        updateVariant();
      });
    });
  }

  /* ---- bundle qty ---- */
  document.addEventListener('change', function (e) {
    var opt = e.target.closest('input[name="bundle"]');
    if (!opt) return;
    var hiddenQty = document.querySelector('[data-product-quantity]');
    if (hiddenQty) hiddenQty.value = opt.value;
  });

  /* ---- PDP buttons ----
     [data-fn-pdp-add]  "Dodaj v košarico" → AJAX add, STAY on page, show
                        "✓ Dodano!", refresh the header cart bubble.
     [data-fn-buy-now]  "Naroči zdaj"  → AJAX add, then GO to /cart. */
  function fnPdpError(btn, orig) {
    btn.disabled = false;
    btn.textContent = orig;
    var errEl = document.querySelector('[data-fn-checkout-error]');
    if (errEl) { errEl.textContent = 'Prišlo je do napake. Poskusite znova.'; errEl.hidden = false; }
  }
  function fnRefreshBubble() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { source: 'fn-pdp', data: { itemCount: cart.item_count } }
        }));
      })
      .catch(function () {});
  }
  /* "U košarico" = AJAX add only, STAY on the PDP (no native submit → no
     /cart redirect, and Releasit doesn't intercept a type="button"). FormData
     captures the quantity Vitals writes to input[name="quantity"] on tier select. */
  var pdpAtcController = null;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fn-pdp-add]');
    if (!btn || btn.disabled) return;

    /* fn-cod-bridge is active: the add must go through Vitals (product + tier
       gift), so this AJAX add stands down and lets the event reach Vitals. */
    if (window.FN_COD_BRIDGE) return;

    /* Guard: never intercept Releasit Buy-Now button clicks */
    if (e.target.closest('.releasit-btn, .releasit-cob-btn, [data-releasit], #rsi_buy_now_button, #_rsi-buy-now-button')) return;

    e.preventDefault();
    e.stopImmediatePropagation(); /* prevent any other listener (Releasit, theme) from redirecting */
    var form = btn.closest('form') || document.querySelector('.fn-pdp__form');
    if (!form) return;

    if (window.fnSyncVitalsQty) window.fnSyncVitalsQty(); /* pull selected Vitals tier qty into the form */

    /* Abort previous in-flight request if user double-clicks */
    if (pdpAtcController) pdpAtcController.abort();
    pdpAtcController = new AbortController();

    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...'; /* Task 2 requirement */

    /* Read qty from visible stepper (may be outside form if reorderQtyBeforeVitals ran) */
    var qtyInput = document.querySelector('[data-qty-input]') || form.querySelector('[name="quantity"]');
    var variantInput = form.querySelector('[name="id"]');
    var qty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty }),
      signal: pdpAtcController.signal
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        fnRefreshBubble();
        if (window.fnShowToast) window.fnShowToast('Dodano v košarico ✓');
        if (window.fnCelebrate) window.fnCelebrate(); /* Task 2 requirement */
        btn.textContent = '✓ Dodano!';
        btn.classList.add('fn-btn-success');
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = orig;
          btn.classList.remove('fn-btn-success');
        }, 2000);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        fnPdpError(btn, orig);
        if (window.fnShowToast) window.fnShowToast('Napaka — poskusite znova', true); /* Task 2 requirement */
      })
      .finally(function() {
        pdpAtcController = null;
      });
  }, true /* capture phase: run BEFORE Vitals' vx-atc-btn handler so its
            "go to /cart" redirect never fires — the add stays on the PDP */);

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var main = document.querySelector('[data-pdp-main-image]');
    if (main) main.src = t.getAttribute('data-src');
    document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
    t.classList.add('is-active');
  });

  /* ---- recommendations ---- */
  (function () {
    var box = document.querySelector('[data-pdp-recs]');
    var grid = document.querySelector('[data-pdp-recs-grid]');
    if (!box || !grid) return;
    var pid = box.getAttribute('data-product-id');
    if (!pid) { box.style.display = 'none'; return; }
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var ps = (data.products || []).filter(function (p) { return p.variants && p.variants[0] && p.variants[0].available; }).slice(0, 4);
        if (!ps.length) { box.style.display = 'none'; return; }
        grid.innerHTML = ps.map(function (p) {
          var title = (p.title || '').replace(/"/g, '&quot;');
          var v = p.variants[0];
          var multi = p.variants.length > 1;
          var img = p.featured_image
            ? p.featured_image.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_400x400$1$2')
            : '';
          return '<div class="fn-pdp-rec">' +
            '<a href="' + p.url + '" class="fn-pdp-rec__link">' +
              '<div class="fn-pdp-rec__media"><img src="' + img + '" alt="' + title + '" width="400" height="400" loading="lazy"></div>' +
              '<div class="fn-pdp-rec__title">' + p.title + '</div>' +
            '</a>' +
            '<div class="fn-pdp-rec__foot">' +
              '<span class="fn-pdp-rec__price">' + money(p.price) + '</span>' +
              '<button type="button" class="fn-quick-add fn-pdp-rec__add" data-quick-add data-variant-id="' + v.id + '" data-multiple-variants="' + multi + '" data-product-url="' + p.url + '" aria-label="Hitro v košarico: ' + title + '">' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>';
        }).join('');
      })
      .catch(function () { box.style.display = 'none'; });
  })();
})();

/* PDP quantity selector +/- (delegated). The input carries name="quantity"
   inside the product form, so FormData picks it up on add-to-cart. */
(function fnPdpQty() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fn-qty-minus, .fn-qty-plus');
    if (!btn) return;
    var wrap = btn.closest('[data-qty-wrap], .vx-qty-wrap, .fn-qty-selector, .fn-qty-controls');
    var input = wrap && wrap.querySelector('.fn-qty-input, [data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 10;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    if (btn.classList.contains('fn-qty-plus')) { if (val < max) val++; }
    else { if (val > min) val--; }
    input.value = val;
    /* Dispatch BOTH input + change (bubbling) so the Vitals volume-discount
       widget — which listens for either on input[name="quantity"] — recalculates
       its selected tier. Vitals writes back to this same input, so its changes
       show in our display automatically (single shared input). */
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* =============================================================
   fnPlaceReleasitBelowAtc — places and wires the Releasit COD
   button directly below the ATC button on the PDP.
   ============================================================= */
(function fnPlaceReleasitBelowAtc() {
  var form = document.querySelector('.fn-pdp__form');
  if (!form) return;
  function wireBtn(btn) {
    if (btn.dataset.fnRelWired) return;
    btn.dataset.fnRelWired = '1';
    btn.addEventListener('click', function (e) {
      /* fn-cod-bridge owns the buy click (document capture, runs first). */
      if (window.FN_COD_BRIDGE) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var pdpForm = document.querySelector('.fn-pdp__form');
      if (!pdpForm) return;
      var variantInput = pdpForm.querySelector('[name="id"]');
      var qtyInput = document.querySelector('[data-qty-input]') || pdpForm.querySelector('[name="quantity"]');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      var qty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
      if (!variantId) return;
      window.fnOpenCheckout({ addProduct: { id: variantId, qty: qty }, button: btn });
    }, true);
  }
  function place() {
    var rel = document.getElementById('releasit-cob')
           || document.querySelector('.vx-releasit-wrap')
           || document.getElementById('rsi_buy_now_button')
           || document.getElementById('_rsi-buy-now-button');
    var actions = document.querySelector('.fn-pdp-actions');
    if (!rel || !actions) return;
    var target = rel.closest('.vx-releasit-wrap') || rel;
    var btns = target.tagName === 'BUTTON' ? [target] : Array.from(target.querySelectorAll('button'));
    btns.forEach(wireBtn);
    if (actions.nextElementSibling === target || actions.nextElementSibling === rel) return;
    actions.insertAdjacentElement('afterend', target);
  }
  place();
  /* Coalesced + inert while the COD form is open — see the same note in
     sections/main-product.liquid. */
  var _relQueued = false;
  function placeSoon() {
    if (_relQueued) return;
    if (window.fnCodFormIsOpen && window.fnCodFormIsOpen()) return;
    _relQueued = true;
    requestAnimationFrame(function () { _relQueued = false; place(); });
  }
  var fnRelObserver = new MutationObserver(placeSoon);
  fnRelObserver.observe(document.documentElement, { childList: true, subtree: true });
  [200, 600, 1200, 2500, 5000].forEach(function (t) { setTimeout(place, t); });
  setTimeout(function () { if (fnRelObserver) fnRelObserver.disconnect(); }, 15000);
})();

// ── Related slider arrow nav ────────────────────────────────────────────────
;(function vxRelated() {
  'use strict';
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  function init() {
    var wrap = document.querySelector('[data-related]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-track]');
    if (!track) return;
    /* Arrows removed — track is swipeable. Touch scrolls natively (momentum
       via -webkit-overflow-scrolling). Add pointer-drag for desktop mouse. */
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; /* let native touch scroll handle it */
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function end() { down = false; track.classList.remove('is-dragging'); }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);
    /* Prevent a drag from triggering a card link/button click */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
})();

/* =============================================================
   fnReleasitPurchase — fire Meta Pixel / GA4 / TikTok Purchase
   when Releasit COD completes an order.

   Releasit signals order completion via:
   1. Custom DOM events (releasit:order_placed / completed variants)
   2. postMessage from its iframe
   3. window.releasitOrderPlaced callback (some versions)

   Dedup via event_id (order_id when available, else timestamp)
   so CAPI + browser pixel don't double-count.
   ============================================================= */
(function fnReleasitPurchase() {
  'use strict';

  var _fired = {};

  function _firePurchase(detail) {
    detail = detail || {};
    /* Derive a stable event ID for dedup */
    var eid = String(detail.order_id || detail.orderId || detail.id || detail.order_number || ('rsi-' + Date.now()));
    if (_fired[eid]) return;
    _fired[eid] = true;

    /* Normalise total — Releasit may send cents or decimal EUR */
    var raw = detail.total_price || detail.total || detail.subtotalPrice || detail.price || 0;
    var val = typeof raw === 'number' && raw > 500 ? raw / 100 : Number(raw) || 0;

    var payload = {
      value:        val,
      currency:     'EUR',
      content_type: 'product',
      event_id:     eid
    };
    if (detail.line_items || detail.lineItems) {
      var items = detail.line_items || detail.lineItems || [];
      payload.content_ids = items.map(function (i) { return String(i.variant_id || i.variantId || i.id || ''); });
    }

    if (window.fbq) window.fbq('track', 'Purchase', payload);
    if (window.gtag) window.gtag('event', 'purchase', { transaction_id: eid, value: val, currency: 'EUR' });
    if (window.ttq) window.ttq.track('PlaceAnOrder', { value: val, currency: 'EUR' });
  }

  /* 1 — DOM / window custom events (all known Releasit event names) */
  var _evNames = [
    'releasit:order_placed', 'releasit:order_completed', 'releasit:purchase',
    'rsi:order_placed',      'rsi:order_completed',      'rsi:purchase',
    'releasit_order_placed', 'releasit_order_completed'
  ];
  _evNames.forEach(function (name) {
    document.addEventListener(name, function (e) { _firePurchase(e.detail); });
    window.addEventListener(name,   function (e) { _firePurchase(e.detail); });
  });

  /* 2 — postMessage from Releasit iframe */
  window.addEventListener('message', function (e) {
    if (!e.data) return;
    var d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (_) { return; } }
    if (typeof d !== 'object') return;
    var t = String(d.type || d.event || '');
    if (/order.?plac|order.?complet|purchase|RELEASIT.*(ORDER|PURCHASE)/i.test(t)) {
      _firePurchase(d.detail || d.data || d.payload || d.order || {});
    }
  });

  /* 3 — window.releasitOrderPlaced callback hook (older Releasit versions) */
  window.releasitOrderPlaced = function (data) { _firePurchase(data || {}); };

  /* 4 — MutationObserver on Releasit thank-you / confirmation element */
  var _obs = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var cls = (node.className || '') + ' ' + (node.id || '');
        if (/thank.you|order.confirm|order.success|rsi.success|releasit.success/i.test(cls)) {
          /* Extract order data from data attributes if available */
          var d = {};
          if (node.dataset) {
            d.order_id  = node.dataset.orderId || node.dataset.order;
            d.total_price = node.dataset.total || node.dataset.totalPrice;
          }
          _firePurchase(d);
        }
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    _obs.observe(document.body, { childList: true, subtree: true });
  });
  if (document.body) _obs.observe(document.body, { childList: true, subtree: true });

})();

/* ============================================================================
   MOBILE STICKY ADD-TO-CART (custom PDP) — show the fixed bottom bar once the
   main ATC scrolls above the viewport, and mirror the live price into it. The
   add itself is handled by the existing [data-fn-pdp-add] capture-phase listener
   (the sticky button carries that attribute), so there is no duplicated cart
   logic here. CSS hides the bar entirely ≥751px (desktop keeps the sticky media
   column instead).
   ========================================================================== */
(function fnPdpStickyAtc() {
  function init() {
    var bar = document.querySelector('[data-pdp-sticky-atc]');
    var mainBtn = document.querySelector('.fn-pdp-actions [data-fn-pdp-add]');
    if (!bar || !mainBtn) return;

    /* Mirror the live PDP price (updates on variant change) into the sticky bar. */
    var livePrice = document.querySelector('[data-pdp-price]');
    var stickyPrice = bar.querySelector('[data-pdp-sticky-price]');
    if (livePrice && stickyPrice) {
      var syncPrice = function () { stickyPrice.textContent = livePrice.textContent; };
      syncPrice();
      new MutationObserver(syncPrice).observe(livePrice, { childList: true, characterData: true, subtree: true });
    }

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        /* show only after the main ATC has scrolled ABOVE the viewport top */
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(mainBtn);
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* related slider arrows: scroll exactly one card per click */
(function vxRelatedArrows() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rel-prev], [data-rel-next]');
    if (!btn) return;
    var wrap = btn.closest('.vx-related__track-wrap');
    var track = wrap && wrap.querySelector('[data-track]');
    if (!track) return;
    var card = track.querySelector('.vx-related__card');
    var step = card ? card.getBoundingClientRect().width + 12 : 240;
    track.scrollBy({ left: btn.hasAttribute('data-rel-next') ? step : -step, behavior: 'smooth' });
  });
})();
/* ==================================================================
   NightForce — product gallery UX v2 (Kenan):
   1. The description gallery mosaic moves to the MIDDLE of the
      description sections.
   2. ONE shared lightbox serves BOTH the description gallery AND the
      main product media carousel: click → fullscreen at natural
      scale (hi-res, uncropped), arrows / keyboard / swipe browsing.
   ================================================================== */
(function nfGalleryLightbox() {
  var ov = null, big = null, count = null, cur = 0, touchX = null, srcs = [];

  function build() {
    ov = document.createElement('div');
    ov.className = 'nf-lightbox';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-label', 'Galerija');
    ov.innerHTML =
      '<button type="button" class="nf-lightbox__close" aria-label="Zapri">✕</button>' +
      '<button type="button" class="nf-lightbox__nav nf-lightbox__nav--prev" aria-label="Prejšnja slika">‹</button>' +
      '<img class="nf-lightbox__img" alt="">' +
      '<button type="button" class="nf-lightbox__nav nf-lightbox__nav--next" aria-label="Naslednja slika">›</button>' +
      '<div class="nf-lightbox__count"></div>';
    big = ov.querySelector('.nf-lightbox__img');
    count = ov.querySelector('.nf-lightbox__count');
    ov.querySelector('.nf-lightbox__close').addEventListener('click', close);
    ov.querySelector('.nf-lightbox__nav--prev').addEventListener('click', function () { show(cur - 1); });
    ov.querySelector('.nf-lightbox__nav--next').addEventListener('click', function () { show(cur + 1); });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    ov.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (dx > 40) show(cur - 1);
      else if (dx < -40) show(cur + 1);
    }, { passive: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(cur - 1);
    else if (e.key === 'ArrowRight') show(cur + 1);
  }

  function show(i) {
    cur = (i + srcs.length) % srcs.length;
    big.src = srcs[cur];
    count.textContent = (cur + 1) + ' / ' + srcs.length;
  }

  function open(list, i) {
    srcs = list;
    if (!ov) build();
    show(i);
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!ov || !ov.parentNode) return;
    ov.parentNode.removeChild(ov);
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
  }

  function wire(imgs) {
    if (!imgs.length) return;
    var list = Array.prototype.map.call(imgs, function (im) {
      return im.getAttribute('data-full') || im.getAttribute('src');
    });
    Array.prototype.forEach.call(imgs, function (im, i) {
      im.style.cursor = 'zoom-in';
      im.addEventListener('click', function (e) {
        e.preventDefault();
        open(list, i);
      });
    });
  }

  function init() {
    /* 1. gallery mosaic → middle of the description sections (the landing
       HTML is one wrapper div, so descend through single-child wrappers) */
    var desc = document.querySelector('.fn-pdp__description');
    var gal = document.querySelector('.fn-pdp__gallery-meta');
    if (desc && gal && gal.parentElement === desc) {
      var host = desc;
      for (var d = 0; d < 6; d++) {
        var els = Array.prototype.filter.call(host.children, function (k) {
          return k !== gal && k.tagName !== 'STYLE' && k.tagName !== 'SCRIPT';
        });
        if (els.length === 1) { host = els[0]; continue; }
        break;
      }
      var kids = Array.prototype.filter.call(host.children, function (k) {
        return k !== gal && k.tagName !== 'STYLE' && k.tagName !== 'SCRIPT';
      });
      if (kids.length > 2) {
        host.insertBefore(gal, kids[Math.ceil(kids.length / 2)]);
      }
    }

    /* 2. one lightbox, two image sets */
    if (gal) wire(gal.querySelectorAll('.fn-pdp__gallery-item img'));
    wire(document.querySelectorAll('.fn-pdp-carousel .fn-pdp-slide img'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();